module.exports = __webpack_public_path__ + "9543dd5832cb36e032405c87793130e7.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/mug-white-design-resized.png
// module id = 790
// module chunks = 0